import { isNil } from "lodash-es";

class ApiClientError extends Error {
  errors: $TSFixMe;

  request: $TSFixMe;

  response: $TSFixMe;

  status: $TSFixMe;

  constructor(
    name: $TSFixMe,
    status: $TSFixMe,
    message: $TSFixMe,
    request: $TSFixMe,
    response: $TSFixMe,
    cause: $TSFixMe,
  ) {
    super(message);

    /* istanbul ignore next */
    this.name = name;
    this.status = status;
    this.request = request;
    this.response = response;
    this.cause = cause;

    /* istanbul ignore next */
    if (this.response && this.response.data) {
      this.errors = this.response.data.errors;
    }
  }

  contains = (type: $TSFixMe, attribute = null) => {
    if (attribute) {
      return (
        !isNil(this.errors) &&
        !isNil(
          this.errors.find(
            (error: $TSFixMe) =>
              error.type === type && error.attribute === attribute,
          ),
        )
      );
    }
    return (
      !isNil(this.errors) &&
      !isNil(this.errors.find((error: $TSFixMe) => error.type === type))
    );
  };

  extractError = (type: $TSFixMe) =>
    this.errors.find((error: $TSFixMe) => error.type === type);
}

export default ApiClientError;
